<template>
  <LayoutTelas
    id="tela__painel"
    :titulo="this.$route.meta.titulo"
    :isLoading="isLoading">
    <h3 v-if="!servicosEmAberto || servicosEmAberto.length === 0">
      Não há atendimentos no momento
    </h3>
    <div class="container">
      <Card
        v-for="servico in servicosEmAberto"
        :key="servico._id"
        :dados="servico"
        @concluir="concluir"
        @lancarProduto="lancarProduto"
        @removerAtendimento="removerAtendimento"
        @alterarCliente="atualizaCliente" />
    </div>

    <ModalConfirmacao
      ref="modalConfirmacao"
      :titulo="dialog.titulo"
      :mensagem="dialog.mensagem"
    />

    <fab
      :position="floatButton.position"
      :bg-color="floatButton.bgColor"
      :fixed-tooltip="true"
      :actions="floatButton.fabActions"
      main-icon="add"
      :start-opened="true"
      @atualizar="carrega" />
    <PainelIndicacaoModal ref="modalIndicacao" />
    <IdentificacaoCliente ref="modalIdentificacaoCliente" />
    <PainelFinalizacaoAtendimento ref="modalFinalizacaoAtendimento" />
    <PainelLancamentoProduto ref="modalLancamentoProduto" />
  </LayoutTelas>
</template>

<script>
import _ from 'lodash'
import fab from 'vue-fab'
import Card from './components/Card.vue'
import PainelIndicacaoModal from './PainelIndicacaoModal.vue'
import PainelFinalizacaoAtendimento from './PainelFinalizacaoAtendimento.vue'
import PainelLancamentoProduto from './PainelLancamentoProduto.vue'

import GeradorMensagens from '@/mixins/GeradorMensagens'
import LancamentoService from '../../services/lancamento.service'

import ModalConfirmacao from '@/components/modal/ModalConfirmacao.vue'
import IdentificacaoCliente from './IdentificacaoCliente.vue'

const botaoFlutuante = {
  bgColor: '#003149',
  position: 'bottom-right',
  fabActions: [
    {
      name: 'atualizar',
      icon: 'sync',
      tooltip: 'Atualizar',
    },
  ],
}

export default {
  components: {
    Card,
    ModalConfirmacao,
    fab,
    PainelIndicacaoModal,
    IdentificacaoCliente,
    PainelFinalizacaoAtendimento,
    PainelLancamentoProduto,
  },
  mixins: [GeradorMensagens],
  data() {
    return {
      isLoading: false,
      servicosEmAberto: [],
      floatButton: botaoFlutuante,
      idFilial: '',
      dialog: {
        titulo: '',
        mensagem: '',
      },
    }
  },
  beforeMount() {
    this.idFilial = this.$store.getters['autenticacao/userObj'].usuario.filial._id
    this.carrega()
  },
  methods: {
    async carrega() {
      try {
        this.mostrarLoading()
        const servicos = await LancamentoService.retornaAtendimentosAbertosFilial(this.idFilial)
        this.servicosEmAberto = servicos.lista
      } catch (error) {
        this.tratarRespostaMsg(error)
      } finally {
        this.mostrarLoading(false)
      }
    },
    mostrarLoading(mostrar = true) {
      this.isLoading = mostrar
    },
    async indicar(item) {
      if (item) {
        this.$refs.modalIndicacao.pop(item.cliente, item.funcionario)
      }
    },
    async concluir(item) {
      if (item) {
        if (typeof item.cliente !== 'string') {
          this._abrirTelaFinalizacao(item)
        } else {
          await this.atualizaCliente(item)
          if (typeof item.cliente !== 'string') {
            this._abrirTelaFinalizacao(item)
          }
        }
      }
    },
    async _concluiAtendimento(atendimento) {
      try {
        this.mostrarLoading()
        const retorno = await LancamentoService.concluirAtendimento(atendimento)
        if (retorno.data) {
          this.servicosEmAberto = _.remove(this.servicosEmAberto,
            (atual) => atual._id !== retorno.data._id)

          this.indicar(retorno.data)
        }
      } catch (error) {
        this.tratarRespostaMsg(error)
      } finally {
        this.mostrarLoading(false)
      }
    },
    async removerAtendimento(atendimentoId) {
      this.dialog.titulo = 'Cancelar atendimento'
      this.dialog.mensagem = 'Deseja cancelar esse atendimento?'

      const podeCancelar = await this.$refs.modalConfirmacao.pop()
      if (podeCancelar) {
        try {
          this.mostrarLoading()
          const retorno = await LancamentoService.removerAtendimento(atendimentoId)
          this.tratarRespostaMsg(retorno)
        } catch (error) {
          this.tratarRespostaMsg(error)
        } finally {
          this.mostrarLoading(false)
          this.carrega()
        }
      }
    },
    async atualizaCliente(atendimento) {
      const cliente = await this._retornaIdentificacaoCliente()
      if (cliente) {
        const indiceRegistro = _.findIndex(this.servicosEmAberto, { _id: atendimento._id })
        this.servicosEmAberto[indiceRegistro].cliente = cliente

        // Retorna o valor da bonificação caso tenha
        if (cliente.bonificacao > 0) {
          const totalComBonificacao = cliente.bonificacao - atendimento.total
          if (totalComBonificacao < 0) {
            this.servicosEmAberto[indiceRegistro].total = Math.abs(totalComBonificacao)
          }
        }
      }
    },
    async _retornaIdentificacaoCliente() {
      const retorno = await this.$refs.modalIdentificacaoCliente.pop()
      if (retorno) {
        return retorno
      }

      return null
    },
    async _abrirTelaFinalizacao(atendimento) {
      const atendimentoConcluir = await this.$refs.modalFinalizacaoAtendimento.pop(atendimento)
      if (atendimentoConcluir) {
        await this._concluiAtendimento(atendimentoConcluir)
      }
    },
    async lancarProduto(atendimento) {
      if (atendimento) {
        if (typeof atendimento.cliente !== 'string') {
          const produtos = atendimento.produtos && atendimento.produtos.lista
            ? atendimento.produtos.lista
            : []

          const totalProdutos = atendimento.produtos && atendimento.produtos.totalProdutos
            ? atendimento.produtos.totalProdutos
            : 0

          const retorno = await this.$refs.modalLancamentoProduto.pop(produtos)
          if (retorno) {
            let total = 0
            if (retorno.lista) {
              total = (retorno.totalProdutos - totalProdutos) + atendimento.total
            } else {
              total = atendimento.total - totalProdutos
            }

            this.$set(atendimento, 'produtos', retorno)
            this.$set(atendimento, 'total', total)
          }
        } else {
          this.atualizaCliente(atendimento)
        }
      }
    },
  },
}

</script>

<style lang="scss" scoped>
@import "@/scss/breakpoints.scss";
@import "@/scss/colors.scss";

#tela__painel {
  display: flex;
  flex-direction: column;
  max-width: 100%;

  @media (min-width: $medium-size) {
    min-width: $small-size;
  }
}

.container {
  display: grid;

  @media (min-width: $small-size) {
    grid-template-columns: repeat(2, 1fr)
  }

  @media (min-width: $medium-size) {
    grid-template-columns: repeat(3, 1fr)
  }

  @media (min-width: $large-size) {
    grid-template-columns: repeat(4, 1fr)
  }
}

</style>
